import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { FilterGroup } from 'apps/find-designers/propTypes';
import CheckableFilterOption from './CheckableFilterOption';

class RadioFilter extends Component {
    constructor(props) {
        super(props);

        this.handleChange = this.handleChange.bind(this);
    }

    getCheckedValue(value) {
        if (!this.props.filter.value) {
            return value === this.props.filter.defaultValue;
        }

        return value === this.props.filter.value;
    }

    handleChange(e) {
        const { name, value } = e.target;

        this.props.onChange(name, value);
    }

    render() {
        return (
            <div>
                {this.props.filter.options.map(option => (
                    <CheckableFilterOption
                        filterOption={option}
                        isChecked={this.getCheckedValue(option.value)}
                        key={option.id}
                        type={'radio'}
                        onChange={this.handleChange}
                    />
                ))}
            </div>
        );
    }
}

RadioFilter.propTypes = {
    onChange: PropTypes.func.isRequired,
    filter: FilterGroup.isRequired,
};

export default observer(RadioFilter);



// WEBPACK FOOTER //
// ./src/js/apps/find-designers/components/Filters/RadioFilter.jsx